<template>
    <div class="offer-slider-container"
        :class="{ 'd-none d-sm-block mt-3': hideMobile, 'd-block d-sm-none': !hideMobile }">
        <VueSlickCarousel v-bind="settings" v-if="productos.length > 0" :key="carouselKey">

            <div class="offer-element" v-for="item in filteredItems" :key="item.id">
                <a class="d-flex justify-content-center" :href="item.url" target="_blank" @click="offerTrack(item)" v-if="item.url">
                    <img :src="item.imgPc" :alt="item.name" class="img-fluid d-none d-sm-block" />
                    <img :src="item.imgMo" :alt="item.name" class="img-fluid d-sm-none d-block" />
                </a>

                <div class="d-flex justify-content-center" v-else>
                    <img :src="item.imgPc" :alt="item.name" class="img-fluid d-none d-sm-block" />
                    <img :src="item.imgMo" :alt="item.name" class="img-fluid d-sm-none d-block" />
                </div>
            </div>

        </VueSlickCarousel>

    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import fire from '../fire';
export default {
    name: 'OfferSlider',
    components: { VueSlickCarousel },
    props: {
        hideMobile: Boolean,
    },
    data() {
        return {
            settings: {
                arrows: true,
                dots: false,
                centerMode: true,
                slidesToShow: 1,
            },
            productos: [],
            nombre: "",
            imagen: null,
            url: "",
            order: "",
            moHide: null,
            loading: false,
            count: 0
        }
    },
    watch: {
        productos() {
            this.forceRerender()
        },
    },
    methods: {
        forceRerender() {
            this.carouselKey += 1
        },
        offerTrack(item) {
            fire.analytics().logEvent('banner_' + item.order, { item_id: 'button_click', item_name: 'banner_' + item.order });
            let counter;
            if (item.count) {
                counter = item.count += 1;
            } else { counter = 1; }
            console.log(counter);
            fire
                .database()
                .ref("side_offers/" + item.id)
                .update(
                    {
                        count: counter
                    },
                    function (error) {
                        if (error) {
                            console.log("Error to save the click");
                        } else {
                            console.log("Banner click saved");
                        }
                    }
                );
        },
        fetchData() {
            const sideOffersRef = fire.database().ref('side_offers');
            // .once solo recibe una ves la data en cambio .on la recibe en tiempo real
            sideOffersRef.on('value', (snapshot) => {
                const data = snapshot.val()
                if (data) {
                    this.productos = [];
                    this.productos = Object.values(data)
                    this.productos.sort((a, b) => a.order - b.order);
                    /* console.log('Productos:', this.productos); */
                }
            })
        },
    },
    computed: {
        filteredItems() {
            return this.productos.filter(item => {
                return item.moHide !== true || (item.moHide === true && this.hideMobile);
            });
        },

    },
    mounted() {
        this.fetchData();
    }
}
</script>

<style src="../styles/offerSlider.scss" lang="scss"></style>
